import isArray from 'lodash/isArray';
import merge from 'lodash/merge';
import {TextProps} from './TextProps.interface';

export function Text({children, fontFeature, style, ...props}: TextProps) {
  return (
    <span
      style={merge(
        {
          fontFeatureSettings: isArray(fontFeature)
            ? fontFeature.map(feature => `'${feature}'`).join(', ')
            : fontFeature,
        },
        style
      )}
      {...props}
    >
      {children}
    </span>
  );
}
